var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLlmIcon = function SvgLlmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 5,
    y: 5,
    fill: "#F16A12",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.5 19v-6h1.444v4.831h2.123V19zM12.838 19v-6h1.444v4.831h2.123V19zM22.103 19v-4.151h-.065L20.874 19h-1.136l-1.155-4.151h-.066V19h-1.36v-6h2.078l1.07 3.846h.066L21.44 13H23.5v6z"
  })));
};
export default SvgLlmIcon;